import React from "react";

import "./static/ripple.css";
import ripple from "../../static/svgs/Ripple.svg";
export const Ripple = (props?:any) => <div className="loader_container flex-center p-1" style={{minHeight: props?.minHeight || "100vh"}}>
  <div className="loader__sub-container p-2 br-1">
    <img className="loader" src={ripple} style={props?.style} />
    {/* <p className="text-center fw-600 fs-c-base">Loading...</p> */}
  </div>
  </div>;
export const RippleForInput = () => (
  <img className="loader_for_input" src={ripple} />
);
export default Ripple